export const firebaseConfig = {
  apiKey: "AIzaSyAPxJBet5TAXNnbc2ANcoFAxChg2KooiNY",
  authDomain: "untamed-isles-dev.firebaseapp.com",
  projectId: "untamed-isles-dev",
  storageBucket: "untamed-isles-dev.appspot.com",
  messagingSenderId: "769614781058",
  appId: "1:769614781058:web:ed6240b706da972645729b"
};
